import React from "react";
import { ProductsPage } from "./Products";

export const DashboardPage = () => {
  return <ProductsPage />;
};
